import { apiV1 } from './client';

/**
 * The Analytics filter card keeps camelCase state; the backend reads
 * snake_case query params. Sending camelCase used to make FastAPI drop every
 * filter silently, so the page showed organisation-wide numbers under an
 * "N active" badge. Always build params through this helper.
 */
const FILTER_KEYS = {
  regionId: 'region_id',
  branchId: 'branch_id',
  officeId: 'office_id',
  agentId: 'agent_id',
  partnershipId: 'partnership_id',
  listingRef: 'listing_ref',
  qrCodeId: 'qr_code_id',
};

export function toFilterParams(filters = {}) {
  const out = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    out[FILTER_KEYS[key] || key] = value;
  });
  return out;
}

const get = async (path, params) => (await apiV1.get(path, { params: toFilterParams(params) })).data;

export const analyticsApi = {
  // QR scan KPIs for the window
  getOverview: (params = {}) => get('/analytics/overview', params),
  // QR scans per SAST bucket (granularity: hour/day/week/month)
  getScansOverTime: (params = {}) => get('/analytics/scans/over-time', params),
  getRecentScans: (params = {}) => get('/analytics/scans/recent', params),
  // groupBy: by-device | by-country | by-os | by-browser | by-city; params.type: qr | url | all
  getBreakdown: (groupBy, params = {}) => get(`/analytics/breakdown/${groupBy}`, params),
  // visits -> landing page views -> form submissions
  getFunnel: (params = {}) => get('/analytics/funnel', params),
  getGrouped: (groupBy, params = {}) => get(`/analytics/grouped/${groupBy}`, params),
  // every link type, one series each
  getActivityOverTime: (params = {}) => get('/analytics/activity/over-time', params),
  // period totals for the Dashboard cards
  getActivitySummary: (params = {}) => get('/analytics/activity/summary', params),
  getActivity: (params = {}) => get('/analytics/activity', params),
  getActivityDevices: (params = {}) => get('/analytics/activity/devices', params),
  getActivityGeo: (params = {}) => get('/analytics/activity/geo', params),
};

export default analyticsApi;
